





















import Vue from 'vue';
import api from '@/shared/api';

type Option = {
  value: string | number;
  label: string;
};

interface Props {
  value: number;
  url: string;
  optionsLabel: string;
  optionsValue: string;
  program: number;
  placeholder: string;
}

interface Data {
  selected: Props['value'];
  options: Option[];
  loading: boolean;
}

interface Methods {
  remoteMethod: (query: string) => Promise<void>;
  update: (value: number) => void;
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: 'TeenLookup',
  props: {
    value: {},
    url: {},
    optionsLabel: {},
    optionsValue: {},
    program: {},
    placeholder: {}
  },
  data () {
    return {
      selected: this.value,
      options: [],
      loading: false
    };
  },
  watch: {
    program: function () {
      this.options = [];
    }
  },
  methods: {
    async remoteMethod (query) {
      if (query !== '') {
        this.loading = true;
        const response = await api.summerIncidentReportTeenLookup(query, this.program);
        this.loading = false;
        if (response && response.status === 200) {
          this.options = response.data.map(item => {
            const label = item.Person.FullName;
            const value = item.personID;
            return { label, value };
          });
        }
      }
    },
    update: function (value) {
      this.$emit('input', value);
    }
  }
});
